import { useState } from 'react';
import * as Yup from 'yup';
import { yupToFormErrors } from 'formik';
import { userStore } from 'store/user';
import _ from 'lodash';

interface ShopFormValidationProps {
  defaultForm: any;
  values: any;
}

const useShopFormValidation = (
  initialState: ShopFormValidationProps = {
    defaultForm: {},
    values: {},
  },
) => {
  const { values } = initialState;
  const [errors, setErrors] = useState<any>({
    basic: {},
    products: '',
  });
  const { seller } = userStore();
  // productId
  const validationSchema = Yup.object().shape({
    name: Yup.string().required('素材名稱必填'),
    bannerUrl: Yup.string().when(seller, {
      is: (seller: string) => seller === '1P',
      then: (schema) =>
        schema
          .test(
            'bannerUrl-needUrl',
            '素材網址必填',
            (value: string | undefined) => {
              if (values.bannerExtra.categoryCode !== '') {
                return true;
              }
              return !!value;
            },
          )
          .test(
            'bannerUrl-needUrl',
            '請輸入包含 http(s):// 的網址',
            (value: string | undefined) => {
              const urlExpression =
                /(^https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|^https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,})/;
              if (values.bannerExtra.categoryCode !== '') {
                return true;
              }
              return !!value && urlExpression.test(value);
            },
          )
          .test(
            'bannerUrl-needMomo',
            '網址域名應為 momoshop.com.tw',
            (value: string | undefined) => {
              const urlRegex =
                /^https?:\/\/(?:[a-zA-Z0-9]+\.)?momoshop\.com\.tw(?:\/.+)?$/;
              if (values.bannerExtra.categoryCode !== '') {
                return true;
              }
              return !!value && urlRegex.test(value);
            },
          )
          .test(
            'bannerUrl-needCn',
            '請填寫符合提示的網址',
            (value: string | undefined) => {
              const urlRegex = /cn=([0-9]{10,})(?=&|\b)/;
              if (values.bannerExtra.categoryCode !== '') {
                return true;
              }
              return !!value && urlRegex.test(value);
            },
          ),
    }),
    bannerExtra: Yup.object().shape({
      webBrandNo: Yup.string().required('請選擇品牌'),
      categoryCode: Yup.string().when('webBrandNo', {
        is: (webBrandNo) => seller === '1P' && webBrandNo !== '',
        then: (schema) =>
          schema
            .required('請選擇旗艦館')
            .test(
              'categoryCode-need',
              '請選擇旗艦館',
              (value: string | undefined) => value !== '',
            ),
      }),
    }),
    product: Yup.object().test(
      'is-required',
      '尚未選擇主打品',
      (value) => !_.isEmpty(value),
    ),
  });

  // 即時驗證表單
  const handleValidation = () => {
    validationSchema
      .validate(values, { abortEarly: false })
      .then(function () {
        setErrors({});
      })
      .catch(function (err) {
        // console.log('err', err);
        setErrors(yupToFormErrors(err));
        console.log('errors', yupToFormErrors(err));
      });
  };

  return { validationSchema, errors, setErrors, handleValidation };
};

export default useShopFormValidation;
